import React from 'react';

const IconLogo = () => (
  <svg
    id="logo"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="1000.000000pt"
    height="1000.000000pt"
    viewBox="0 0 1000.000000 1000.000000"
    preserveAspectRatio="xMidYMid meet">
    <g
      transform="translate(0.000000,1000.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none">
      <path
        d="M4770 9751 c-124 -71 -430 -248 -681 -393 -251 -144 -1101 -634
-1887 -1088 l-1431 -825 -1 -2445 0 -2445 1238 -714 c680 -393 1630 -942 2110
-1219 514 -296 880 -502 890 -499 9 2 406 229 882 504 476 274 1422 821 2102
1214 l1238 714 -1 2445 0 2445 -1621 935 c-891 514 -1724 995 -1852 1069 -568
327 -749 431 -755 431 -4 0 -108 -58 -231 -129z m2171 -1347 c1064 -614 1944
-1121 1957 -1127 l22 -10 0 -2266 0 -2266 -98 -57 c-1487 -863 -3817 -2199
-3830 -2195 -13 3 -3045 1749 -3814 2195 l-98 57 0 2268 c0 1247 3 2267 8
2267 4 0 882 506 1952 1124 1070 618 1950 1125 1956 1125 7 1 882 -501 1945
-1115z"
      />
      <path
        d="M4661 7038 c-40 -106 -113 -296 -161 -423 -48 -126 -397 -1040 -775
-2030 -378 -990 -690 -1806 -692 -1812 -4 -10 61 -13 305 -13 l309 0 100 278
c56 152 149 413 209 579 l109 303 931 0 931 0 16 -42 c9 -24 104 -283 212
-577 107 -294 196 -536 198 -538 2 -2 141 -2 309 -1 l305 3 -828 2165 c-455
1191 -840 2195 -854 2233 l-27 67 -262 0 -261 0 -74 -192z m718 -1606 c198
-543 362 -995 366 -1004 7 -17 -33 -18 -745 -18 -637 0 -751 2 -748 14 2 8
170 473 373 1035 352 972 371 1020 383 991 7 -17 174 -475 371 -1018z"
      />
    </g>
  </svg>
);

export default IconLogo;
